<template>
  <div class="position-relative">
    <div v-if="isShowMoreTabsContainer" class="c-tabs-overlay" @click="isShowMoreTabsContainer = false"></div>
    <div v-if="isShowLeftShadow" class="c-tabs-left-shadow"></div>
    <div :id="id ? id : 'c-tabs-container'" class="c-tabs">
      <div
        v-for="(item, index) in items"
        :id="id ? `${id}-c-tab-${index}` : `c-tab-${index}`"
        :key="item.value"
        class="c-tabs-item"
        :class="{
          'c-tabs-item_active': isActive(item.value),
          'c-tabs-item_disabled': item.disabled,
        }"
        v-b-popover.html="{
          container: '#app',
          trigger: 'hover blur',
          boundary: 'window',
          content: item.label,
          placement: 'top',
        }"
        @click="(e) => selectTab(e, item)"
      >
        <div class="c-tabs-item-label">{{ item.label }}</div>
      </div>
      <div
        v-if="isShowMoreTabsButton"
        class="c-tabs-item c-tabs-item-more"
        :class="{
          'c-tabs-item_active': false,
        }"

      >
        <div class="c-tabs-item-label" @click="isShowMoreTabsContainer = !isShowMoreTabsContainer">Ещё..</div>
        <div v-if="isShowMoreTabsContainer && moreTabs.length > 0" class="c-tabs-item-more-container">
          <div class="c-tabs-item-more-container-list">
            <div
              v-for="(moreTab, index) in moreTabs"
              :key="`tabs-${index}`"
              :class="{
                'c-tabs-item-more-container-list-item-active': isActive(moreTab.value),
              }"
              class="c-tabs-item-more-container-list-item"
              @click="(e) => selectTab(e, moreTab)"
            >
              <div class="c-tabs-item-more-container-list-item-label">
                {{ moreTab.label }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isShowRightShadow" class="c-tabs-right-shadow"></div>
    <div class="c-tabs-shadow"></div>
  </div>
</template>

<script>
export default {
  name: "c-tabs",

  props: ["id", "active", "items", "withRouting", "withNamingRouting", "namingParam", "currentQuery"],

  data() {
    return {
      activeTab: this.active,
      isShowMoreTabsButton: false,
      isShowMoreTabsContainer: false,
      isShowRightShadow: false,
      isShowLeftShadow: false,
      moreTabs: [],
    };
  },

  watch: {
    active(value) {
      //this.isShowMoreTabsContainer=false;
      this.activeTab = value;
    },

    activeTab(value) {
      this.isShowMoreTabsContainer=false;
      this.$emit("change", value);
    },

    items() {
      this.setShowMoreButtonTabs();
    },
  },

  mounted() {
    this.setShowMoreButtonTabs();
    document.querySelector(".c-tabs").addEventListener("scroll", this.handleTabsScroll);

    const tabsContainer = document.getElementById("c-tabs-container");
    const layout = document.querySelector(".layout").clientWidth;

    if (tabsContainer.scrollWidth > layout && layout <= 768) {
      this.isShowRightShadow = true;
    }
  },

  created() {
    const vm = this;
    this._resizeCb = () => {
      vm.setShowMoreButtonTabs();
    };
    window.addEventListener("resize", this._resizeCb);
  },

  beforeUnmount() {
    window.removeEventListener("resize", this._resizeCb);
    this._resizeCb = null;
  },

  methods: {
    method(name, value) {
      console.log(name, value);
    },
    handleTabsScroll() {
      const layout = document.querySelector(".layout").clientWidth;
      const tabsContainer = document.getElementById("c-tabs-container");

      if (tabsContainer.scrollWidth > layout && layout <= 768) {
        if (tabsContainer.scrollLeft > 0) {
          this.isShowLeftShadow = true;
        } else {
          this.isShowLeftShadow = false;
        }

        if (tabsContainer.scrollLeft === tabsContainer.scrollWidth) {
          this.isShowRightShadow = false;
        } else {
          this.isShowRightShadow = true;
        }
      }
    },

    selectTab(e, item) {
      this.isShowMoreTabsContainer = false;
      if (item.link) {
        window.location.href = item.link;
      }
      // e.target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
      const elementOffset = e.target.parentNode.offsetLeft;
      const tabsContainerScrollLeft = e.target.parentNode.parentNode.scrollLeft;
      if (
        elementOffset > tabsContainerScrollLeft ||
        e.target.parentNode.offsetLeft < e.target.parentNode.parentNode.scrollLeft
      ) {
        e.target.parentNode.parentNode.scrollTo({
          top: 0,
          left: e.target.parentNode.offsetLeft - 30,
          behavior: "smooth",
        });
      }
      // console.log(e.target.offsetLeft)
      // console.log(e.target.parentNode.parentNode.scrollLeft)

      if (this.withNamingRouting !== undefined) {
        if (this.$route.params[this.namingParam] !== item.value) {
          this.$router.replace({
            name: this.withNamingRouting,
            params: { [this.namingParam]: item.value },
            query: this.currentQuery,
          });
        }
        return;
      }

      if (this.withRouting === undefined) {
        this.activeTab = item.value;
      } else if (this.$route.name !== item.value) {
        this.$router.replace({ name: item.value, query: item.query });
      }
    },

    isActive(value) {
      if (this.withNamingRouting !== undefined) {
        return this.$route.params[this.namingParam] === value;
      }

      if (this.withRouting === undefined) {
        return this.activeTab === value;
      }
      return this.$route.name === value;
    },

    setShowMoreButtonTabs() {
      let layout;
      if (this.id !== undefined) {
        setTimeout(() => {
          if (document.getElementById(this.id) !== null) {
            layout = document.getElementById(this.id).parentElement.clientWidth;
            const layoutWidth = layout;

            setTimeout(() => {
              this.moreTabs = [];
              if(Array.isArray(this.items)) {
                this.items.forEach((tab, index) => {
                  const tabElement = document.getElementById(`${this.id}-c-tab-${index}`);
                  if (tabElement !== null) {
                    tabElement.style.display = "block";
                    if (tabElement.offsetLeft > layoutWidth - tabElement.offsetWidth - 80) {
                      tabElement.style.display = "none";
                      this.moreTabs.push(tab);
                      if (!this.isShowMoreTabsButton) this.isShowMoreTabsButton = true;
                    }
                  }
                });
              }
            }, 100);
          }
        }, 100);
      } else {
        layout = document.querySelector(".layout").clientWidth;
        const layoutWidth = layout;
        setTimeout(() => {
          this.moreTabs = [];
          this.items.forEach((tab, index) => {
            const tabElement = document.getElementById(`c-tab-${index}`);
            if (!tabElement) return;
            tabElement.style.display = "block";
            if (layoutWidth > 768 && tabElement.offsetLeft > layoutWidth - tabElement.offsetWidth - 80) {
              tabElement.style.display = "none";
              this.moreTabs.push(tab);
              if (!this.isShowMoreTabsButton) this.isShowMoreTabsButton = true;
            }
          });
        }, 100);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.c-tabs {
  margin: 0 -30px;
  padding: 0 30px;
  position: relative;
  display: flex;
  width: calc(100% + 60px);
  align-items: flex-end;

  @media screen and (max-width: 768px) {
    width: calc(100% + 60px);
    overflow-x: auto;
    overflow-y: hidden;
    padding-bottom: 4px;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  &-overlay {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }

  &-left-shadow {
    @media screen and (max-width: 768px) {
      position: absolute;
      background: linear-gradient(270deg, rgba(255, 255, 255, 0) 10%, #ffffff 100%);
      pointer-events: none;
      top: -10px;
      z-index: 2;
      left: -30px;
      height: calc(100% + 10px);
      width: 35px;
    }
  }

  &-right-shadow {
    @media screen and (max-width: 768px) {
      position: absolute;
      background: linear-gradient(90deg, rgba(255, 255, 255, 0) 10%, #ffffff 100%);
      pointer-events: none;
      top: -10px;
      z-index: 2;
      right: -30px;
      height: calc(100% + 10px);
      width: 35px;
    }
  }

  &-shadow {
    content: "";
    background: linear-gradient(0, #8e9cbb 0%, #ffffff 100%);
    opacity: 0.2;
    position: absolute;
    z-index: 3;
    pointer-events: none;
    bottom: 0;
    height: 12px;
    width: calc(100% + 100px);
    left: -50px;
    @media (max-width: 768px) {
      bottom: 4px;
    }
  }

  &-item {
    padding-bottom: 8px;
    margin-left: 30px;
    cursor: pointer;
    position: relative;

    &:first-child {
      margin-left: 0;
    }

    @media screen and (max-width: 768px) {
      &:last-child {
        position: relative;

        &::after {
          position: absolute;
          content: "";
          right: -30px;
          width: 30px;
          height: 100%;
        }
      }
    }

    &-label {
      line-height: 20px;
      white-space: nowrap;
      color: $color-primary;
      font: {
        size: 13px;
        weight: 500;
      }
      transition: 0.2s;
      max-width: 160px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      @media screen and (max-width: 400px) {
        
      }
    }

    &:before {
      content: "";
      position: absolute;
      height: 4px;
      width: 100%;
      background: $color-secondary;
      bottom: -4px;
      opacity: 0;
      visibility: hidden;
      transition: 0.2s;
    }

    &_active {
      .c-tabs-item-label {
        color: $color-font;
      }

      &:before {
        opacity: 1;
        visibility: visible;
      }
    }

    &_disabled {
      cursor: default;
      opacity: 0.4;
      pointer-events: none;
    }

    &-more {
      position: relative;

      &-container {
        width: 250px;
        max-height: 250px;
        position: absolute;
        top: 100%;
        padding: 10px 0;
        z-index: 100;
        right: 0;
        border-radius: 6px;
        background-color: #ffffff;
        box-shadow: 0 4px 16px rgba(0, 15, 38, 0.25);

        &-list {
          overflow: auto;
          margin: 0 10px;
          max-height: 170px;

          &::-webkit-scrollbar {
            width: 4px;
            height: 100%;
          }

          &::-webkit-scrollbar-thumb {
            background: $color-secondary;
            border-radius: 4px;
          }

          &::-webkit-scrollbar-track {
            background: $color-border-alt;
          }

          &-item {
            padding: 1px 14px;
            white-space: normal;
            cursor: pointer;
            width: 100%;
            border-radius: 15px;
            max-width: calc(100% - 5px);

            &-active {
              background: #e1edff;
            }

            &:hover {
              background: #e1edff;
            }

            &-label {
              font-size: 15px;
              width: 100%;
              max-width: 100%;
              overflow-wrap: anywhere;
              text-overflow: ellipsis;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              cursor: pointer;
            }

            @media screen and (max-width: 768px) {
              &:last-child {
                margin-right: 30px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
